import { usePrefetchPendingExperiences } from "../api/experiences/prefetch-pending-experiences";
import { excludeDupProducts } from "../api/initials";
import { useGetShopDomain } from "../api/shops/get-domain";
import {
  useFetchCollectionQuery,
  useFetchProductsProductPickerQuery,
  useFetchProductTagsQuery,
  useFetchProductTypesQuery,
  useFetchProductVendorsQuery,
} from "../generated";

export const usePrefetchQueries = () => {
  // Prefetch Pending experiences for faster loading
  void usePrefetchPendingExperiences();

  // Prefetch experiment history for integration confirmations
  // void usePrefetchPendingExperimentsHistory();

  // get domain
  useGetShopDomain();

  // Pre-fetch shopify products
  useFetchCollectionQuery();
  useFetchProductTypesQuery();
  useFetchProductVendorsQuery();
  useFetchProductTagsQuery();
  useFetchProductsProductPickerQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    variables: {
      first: 20,
      after: null,
      query: excludeDupProducts,
    },
  });
};
